export default __webpack_public_path__ + "static/media/Lens_Abstracted.10e2268b.svg";